import {makeStyles} from '@material-ui/core';
import React from 'react';
import {useActivityFeed} from 'store/activity-feed';

const useStyles = makeStyles(() => ({
  badge: {
    background: '#ffcb2b',
    color: '#000',
    borderRadius: 100,
    padding: '0 7px',
    fontSize: 11,
    fontWeight: 700,
    lineHeight: '20px',
    minWidth: 20,
    textAlign: 'center'
  },
}));
export const FeedBadge = () => {
  const {count} = useActivityFeed();
  const classes = useStyles();
  return count > 0 ? <span className={classes.badge} data-testid="feed-unread">{count}</span> : null;
};
